import { FormControl, TextField, Typography, useTheme } from '@mui/material';
import React, { ChangeEventHandler, FC } from 'react';
import { commonErrorMessage } from 'utils/error-message';

interface AppTextFieldProps {
  id: string;
  label: string;
  placeholder: string;
  value?: string;
  onChange?:
    | ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  require?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  type?: string;
  maxLength?: number;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  disabled?: boolean;
}

const AppTextField: FC<AppTextFieldProps> = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  require,
  error,
  maxLength,
  type,
  onKeyDown,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <FormControl variant='standard' fullWidth>
      <Typography component='p' sx={{ mb: { xs: '4px', sm: '10px' } }}>
        {label}
        {require && (
          <Typography component='span' color={theme.palette.error.main}>
            *
          </Typography>
        )}
      </Typography>
      <TextField
        id={id}
        name={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        inputProps={{
          sx: {
            padding: '10.63px !important',
          },
          maxLength: maxLength,
        }}
        disabled={disabled}
        sx={{
          '& input[type=number]': {
            '-webkit-appearance': 'textfield',
            '-moz-appearance': 'textfield',
            '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
              display: 'none',
            },
          },
        }}
        onKeyDown={onKeyDown}
      />
      {error && (
        <Typography
          sx={{
            color: theme.palette.error.main,
            fontSize: theme.typography.fontSize,
            my: '5px',
          }}
        >
          {error.message || commonErrorMessage.MSE00003(label)}
        </Typography>
      )}
    </FormControl>
  );
};

export default AppTextField;
